import SPECIALTIES from "@/data/specialties";
import { api } from "@/lib/api";

export async function loadManagedSpecialtyNames({ featuredOnly = false } = {}) {
  try {
    const { data } = await api.get("/specialties/catalog", {
      params: { t: Date.now() },
    });
    const names = (data.specialties || [])
      .filter((item) => !featuredOnly || item.featured !== false)
      .map((item) => item.name)
      .filter(Boolean);
    const deduped = Array.from(new Map(names.map((name) => [name.trim().toLowerCase(), name.trim()])).values());
    return deduped.length ? deduped : SPECIALTIES;
  } catch {
    return SPECIALTIES;
  }
}

export { SPECIALTIES };
